export default __webpack_public_path__ + "static/media/CE_slide_bike.3f19f4f3.svg";